import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import Card from "../../Elements/Card";
import Footer, { FooterTab, MobileFooter } from "../GreenHome/Footer";
import useFindDevice from "../CustomHooks/FindDevice";
import { pnpLogo } from "../../_V2/Asserts";
import Select from 'react-select';

import Input from "../../Elements/Input";

import Button from "../../Elements/Button";
import { createIsuue, getIsuueType } from "../../services/dashboard/token";

import { useFormik } from "formik";
import useFormikValidation from "../../vallidation/useFormikValidation";
import * as Yup from "yup";

import { Flip, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./contactus.css";
import axios from "axios";
import { baseURL } from "../../_V2/services/axiosConfig";

function ContactUs() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const options = ["iban", "bban"];
  const [issueType, setIssueType] = useState([]);
  const { isMob, isTab, isLaptop, isLogedIn, email } = useFindDevice();

  const [issueCreateSucc, setIssueCreateSuu] = useState("");
  const [issueCreateErr, setIssueCreateErr] = useState("");
  const [selectedIssueType, setSelectedIssueType] = useState(null);
  const [isTransaction, setIsTransaction] = useState(false);
  const [transactionID, setTransactionID] = useState("");
  const [transactionIDErr, setTransactionIDErr] = useState(false);
  const handleToastClose = () => {
    if (isLogedIn) {
      navigate("/dashboard");
    } else {
      navigate("/");
    }
  };

  useEffect(() => {
    if (issueCreateSucc) {
      toast.success(issueCreateSucc, {
        onClose: () => {},
        autoClose: 2000,
      });
    }
  }, [issueCreateSucc]);

  useEffect(() => {
    if (issueCreateErr) {
      toast.error(issueCreateErr, {
        onClose: () => {},
        autoClose: 2000,
      });
    }
  }, [issueCreateErr]);


  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: '1px solid #D1D5DB',
      borderRadius: '22px',
      backgroundColor: '#007FFF',
      color:'#FFFFFF',
      padding: isMob ? '2px 8px' : isTab ? '8px 10px' : '4px 12px',
      fontSize: isMob ? '12px' : '14px',
      boxShadow: 'none',
      borderColor: state.isFocused ? '#007FFF' : '#D1D5DB',
      minHeight: isMob ? '40px' : isTab ? '44px' : '48px',
      height: isMob ? '40px' : isTab ? '44px' : '48px',
      '&:hover': {
        borderColor: state.isFocused ? '#007FFF' : '#9CA3AF',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
      padding: '0',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      color: '#FFFFFF',
      '&:hover': {
        color: '#FFFFFF',
      },
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
      transition: 'transform 0.2s',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
      border: '1px solid #E5E7EB',
      marginTop: '4px',
    }),
    menuList: (provided) => ({
      ...provided,
      padding: '4px',
      borderRadius: '8px',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? '#007FFF' 
        : state.isFocused 
        ? '#F3F4F6' 
        : 'white',
      color: state.isSelected ? 'white' : '#374151',
      fontSize: isMob ? '12px' : '14px',
      padding: '8px 12px',
      borderRadius: '4px',
      margin: '2px 0',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: state.isSelected ? '#0056CC' : '#F3F4F6',
      },
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#FFFFFF',
      fontSize: isMob ? '12px' : '14px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#FFFFFF',
      fontSize: isMob ? '12px' : '14px',
    }),
  };

  const profileSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Please enter email"),
    query: Yup.string().required("Please enter your query"),
    accType: Yup.string().required("Please select an issue type"),
  });

  const formik = useFormik({
    initialValues: {
      query: "",
      email: email ? email : "",
      accType: "",
    },
    validationSchema: profileSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const { query, email, accType } = values;
      
      // Clear previous messages
      setIssueCreateSuu("");
      setIssueCreateErr("");
      
      try {
          setSubmitting(false);
          const res = await axios.post(`${baseURL}/accounts/tickets`, {
            email,
            issue_category: Number(accType),
            issue: query,
          });
          if (res.data?.status === "Success" || res.status === 200) {
            setIssueCreateSuu("Query raised successfully!");
            resetForm();
            setIsTransaction(false);
          } else {
            setIssueCreateErr("Failed to raise query. Please try again.");
          }
      } catch (error) {
        console.error('Error submitting form:', error);
        setIssueCreateErr("An error occurred while submitting your query. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
  });

  useEffect(() => {
    fetchIsuueType();
  }, []);

  async function fetchIsuueType() {
    try {
      const res = await axios.get(`${baseURL}/accounts/issuecategory`);
      
      if (res?.status === 200) {
        if (res?.data?.data) {
          const transformedOptions = res.data.data.map(item => ({
            value: item.id?.toString() || item.value?.toString(),
            label: item.name || item.label || item.title
          }));
          setIssueType(transformedOptions);
        } else if (res?.data?.status === "Success" && res?.data?.data) {
          const transformedOptions = res.data.data.map(item => ({
            value: item.id?.toString() || item.value?.toString(),
            label: item.name || item.label || item.title
          }));
          setIssueType(transformedOptions);
          
        } else if (Array.isArray(res?.data)) {
          const transformedOptions = res.data.map(item => ({
            value: item.id?.toString() || item.value?.toString(),
            label: item.name || item.label || item.title
          }));
          setIssueType(transformedOptions);
        } else {
          console.error('Unexpected API response structure:', res.data);
          await fetchWithService();
        }
      }
    } catch (error) {
      console.error('Error fetching issue categories with axios:', error);
      await fetchWithService();
    }
  }

  async function fetchWithService() {
    try {
      const res = await dispatch(getIsuueType("/accounts/issuecategory"));
      if (res?.status === "Success") {
        setIssueType(res.data);
      }
    } catch (error) {
      console.error('Error fetching issue categories with service:', error);
    }
  }
  const redirectToLogin = () => {
    navigate("/login");
  };

  const redirectToRegister = () => {
    navigate("/signup");
  };

  const redirectHome = () => {
    navigate("/");
  };

  const transactionHandler = (e) => {
    if (e.target.value) {
      setTransactionIDErr(false);
      setTransactionID(e.target.value);
    } else {
      setTransactionIDErr(true);
    }
  };

  const handleQueryChange = (e) => {
    setSelectedIssueType(e);
    formik.setFieldValue("accType", e.value);
    if (e.value.trim() === "") {
      formik.setFieldError("accType", "");
    } else {
      formik.setFieldError("accType", "");
    }
  }
  
  function renderInput() {
    return (
      <>
        <div className="flex flex-col mx-auto overflow-auto bg-[#FFFFFF] w-[90%] mt-2 shadow-md rounded-[12px] relative laptop-s:w-[70%] laptop-s:!h-[50%]">
          <div className="h-[6px] rounded-tl-[12px] rounded-tr-[12px] bg-gradient-to-r from-[#00C05B] to-[#007FFF]" />
          
          <Card className="flex flex-col mobile-s:pl-4 mobile-s:pt-4 mobile-s:pb-4 mobile-s:pr-4 bg-[#FFFFFF] rounded-bl-[12px] rounded-br-[12px] tablet:pl-12 tablet:pt-12 tablet:pb-12 tablet:pr-12">
            <form
              onSubmit={(e) => {
                if (!transactionID) {
                  setTransactionIDErr(true);
                }
                e.preventDefault();
                formik.handleSubmit();
              }}
              className="w-full space-y-3"
            >
              <div className="flex flex-col tablet:flex-row gap-3">
                <div className="flex-1">
                  <label htmlFor="email" className="block text-[#00000099] mb-2 text-[14px] font-inter">Email</label>
                  <Input
                    type="email"
                    placeholder="Enter Email ID"
                    className={`text-gray-950 ${
                      isLogedIn ? "bg-gray-100" : ""
                    } w-full h-[45px] rounded-full px-4 border border-solid font-interFont border-[#CACACA] text-[12px] outline-none input-focused rounded-full`}
                    id="email"
                    name="email"
                    value={formik.values.email.toLowerCase()}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    autocomplete="off"
                    readOnly={isLogedIn ? "readOnly" : ""}
                  />
                  {formik.touched.email && formik.errors.email && (
                    <span className="block text-[#EF4444] mobile-s:text-[13px] laptop-s:text-[12px] mt-1">
                      {formik.errors.email}
                    </span>
                  )}
                </div>

                <div className="flex-1">
                  <label htmlFor="accType" className="block text-[#00000099] mb-2 text-[14px] font-inter">Select the issue</label>
                  <div className="form-group w-full">
                        <Select
                          id="accType"
                          name="accType"
                          options={issueType}
                          value={selectedIssueType}
                          onChange={handleQueryChange}
                          placeholder="Select Issue Type"
                          styles={customSelectStyles}
                          isSearchable={false}
                          required
                        />
                  </div>
                  {formik.touched.accType && formik.errors.accType && (
                    <span className="block text-red-500 mobile-s:text-[13px] laptop-s:text-[12px] mt-1">
                      {formik.errors.accType}
                    </span>
                  )}
                </div>
              </div>

              <div className="w-full">
                <label htmlFor="message" className="block text-[#00000099] mb-2 text-[14px] font-inter">Describe your issue</label>
                <textarea
                  id="message"
                  rows="4"
                  className="text-gray-950 w-full p-2 rounded-lg border border-solid border-[#CACACA] text-[12px] outline-none input-focused resize-y min-h-[100px]"
                  name="query"
                  value={formik.values.query}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  placeholder="Enter the issue in detail"
                ></textarea>
                {formik.touched.query && formik.errors.query && (
                  <span className="block text-[#EF4444] mobile-s:text-[13px] laptop-s:text-[12px] mt-1">
                    {formik.errors.query}
                  </span>
                )}
              </div>

              <div className="flex flex-col mobile-s:flex-row gap-4 pt-4">
                <Button
                  className={`px-6 py-3 text-[14px] mobile-m:text-[16px] text-[#FFFFFF] rounded-full focus:outline-none focus:shadow-outline ${
                    formik.isSubmitting 
                      ? 'bg-gray-400 cursor-not-allowed' 
                      : 'bg-[#0081F8]'
                  }`}
                  type="submit"
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>

                <Button
                  className={`px-6 py-3 text-[14px] mobile-m:text-[16px] text-[#FFFFFF] font-bold rounded-full focus:outline-none focus:shadow-outline ${
                    formik.isSubmitting 
                      ? 'bg-gray-400 cursor-not-allowed' 
                      : 'bg-gray-500 hover:bg-gray-700'
                  }`}
                  type="button"
                  disabled={formik.isSubmitting}
                  onClick={() => {
                    if (isLogedIn) {
                      navigate("/dashboard");
                    } else {
                      navigate("/");
                    }
                  }}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </Card>
        </div>
      </>
    );
  }

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 9999 }}
        className="mobile-s:w-[70%] mobile-s:ml-[15%] tablet:w-[40%] laptop-s:w-[25%] mobile-s:text-[12px] mobile-m:!text-[14px] tablet:ml-[1%]"
      />
      {isMob === true ? (
        <div
          className={`font-interFont overflow-auto ${
            isMob
              ? "bg-[url('../public/v2/images/bg/auth-bg-mobile.png')]"
              : "bg-[url('../public/v2/images/bg/auth-bg.png')]"
          } bg-cover`}
        >
          <div className="mb-0 mobile-s:h-[580px] mobile-l:h-[620px] w-full px-2 py-5 font-Inter">
            <div className="flex w-full p-2 justify-between items-center border-b border-[#D3D3D31F] mx-auto">
              <div className="flex-shrink-0">
                <img 
                  src={pnpLogo} 
                  alt="pickNdPrizes" 
                  onClick={redirectHome}
                  className="h-12 w-auto"
                />
              </div>
              <div className="text-[10px] font-[400] font-roboto flex gap-1 items-center flex-shrink-0">
                <button
                  className="bg-[#00C05B] text-[8px] py-[6px] px-[8px] rounded-[20px] text-white font-medium whitespace-nowrap"
                  onClick={redirectToLogin}
                >
                  Login
                </button>

                <button
                  className="bg-[#007FFF] text-[8px] py-[6px] px-[6px] rounded-[20px] text-white font-medium whitespace-nowrap"
                  onClick={redirectToRegister}
                >
                  Sign Up For Free
                </button>
              </div>
            </div>

            <div>
              <div className="mt-2 px-2">
                <h2 className="text-[#FFFFFF] text-[18px] text-center font-archivo">
                  How Can We Assist You?
                </h2>
                <p className="text-[10px] text-center text-[#FFFFFF99] px-2 mb-2">
                  Please complete and submit the form below and<br />
                  our team will promptly reach out to assist you.
                </p>
              </div>

              {renderInput()}
            </div>
          </div>

          <MobileFooter />
        </div>
      ) : isTab ? (
        <div className="min-h-screen flex flex-col bg-[url('../public/v2/images/bg/auth-bg.png')] bg-cover bg-no-repeat bg-center">
          <div className="flex-grow w-full p-5 font-interFont flex flex-col">
            <div className="flex w-full px-3 pb-5 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
              <div className="flex-shrink-0">
                <img 
                  src={pnpLogo} 
                  alt="pickNdPrizes" 
                  onClick={redirectHome}
                  className="h-20"
                />
              </div>
              <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-2 items-center flex-shrink-0">
                <button
                  className="bg-[#00C05B] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[1rem] sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                  onClick={redirectToLogin}
                >
                  Login
                </button>

                <button
                  className="bg-[#007FFF] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[0.75rem] sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                  onClick={redirectToRegister}
                >
                  Sign Up For Free
                </button>
              </div>
            </div>

            <div className="mt-10 mb-10">
              <h2 className="text-[#FFFFFF] text-[28px] text-center font-archivo font-semibold">
                How Can We Assist You?
              </h2>
              <p className="text-[20px] text-center text-[#FFFFFF99] mt-2">
                Please complete and submit the form below and<br />
                our team will promptly reach out to assist you.
              </p>
            </div>

            {renderInput()}
          </div>
          <FooterTab />
        </div>
      ) : (
        <div className="min-h-screen flex flex-col  overflow-auto bg-[url('../public/v2/images/bg/auth-bg.png')] bg-cover">
          <div className="flex-1 h-[100vh] w-full p-5 laptop-min:h-[620px] laptop-s:h-[820px]  laptop-l:h-[818px] font-Inter">
            <div className="flex p-3 items-center justify-between border-b border-[#D3D3D31F] w-[95%] mx-auto">
              <div className="flex-shrink-0">
                <img src={pnpLogo} alt="pickNdPrizes" onClick={redirectHome} className="h-20 cursor-pointer"></img>
              </div>
              <div className="laptop-banner:text-[15px] text-[12px] font-[400] font-roboto flex laptop-banner:gap-5 gap-2 items-center flex-shrink-0">
                <button
                  className="bg-[#00C05B] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[1rem] sm:px-[1.5rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                  onClick={redirectToLogin}
                >
                  Login
                </button>

                <button
                  className="bg-[#007FFF] text-[9px] sm:text-[11px] md:text-[14px] py-[9px] px-[0.75rem] sm:px-[1rem] md:px-[1.15rem] rounded-[30px] text-white font-medium whitespace-nowrap"
                  onClick={redirectToRegister}
                >
                  Sign Up For Free
                </button>
              </div>
            </div>

            <div className="mt-12">
              <div>
                <h2 className="text-[#FFFFFF] text-[32px] text-center font-archivo font-semibold">
                  How Can We Assist You?
                </h2>
                <p className="text-[16px] text-center text-[#FFFFFF99]">
                  Please complete and submit the form below and our team will<br />
                  promptly reach out to assist you.
                </p>
              </div>

              {renderInput()}
            </div>
          </div>
          <>
          <MobileFooter />
          <FooterTab componnent="rules" />
          <Footer componnent="rules" />
        </>
        </div>
      )}
    </>
  );
}

export default ContactUs;